<template>
  <div>
    <narrowBanner/>
    <br/>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <nav class="breadcrumb is-small" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/">首頁</router-link></li>
              <li class="is-active"><router-link to="" aria-current="page">活動新聞</router-link></li>
            </ul>
          </nav>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">

        <div class="columns is-variable is-1-mobile is-8-desktop">
          <div class="column is-two-thirds">
            <div class="content">
              <div class="field is-grouped">
                <p class="control has-icons-left is-expanded">
                  <input class="input is-shadowless" type="text" placeholder="Search ..." v-model="searchText" v-on:keyup.enter="getContent()">
                  <span class="icon is-small is-left">
                    <i class="fas fa-search"></i>
                  </span>
                </p>
                <template v-if="searchText">
                  <div class="control">
                    <a class="button" @click="resetSearch()">
                      <span>Reset</span>
                      <span class="icon is-small">
                        <i class="fas fa-times"></i>
                      </span>
                    </a>
                  </div>
                </template>
              </div>
              <br/>
              <div ref="loadingElement" style="position: relative">
                <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

                <div v-for="(post, index) in paginatedData(current, perPage)" :key="'post-' + index">
                  <p>
                    <router-link :to="{ name: 'post', params: { uid: post.uid } }" class="title is-size-4">
                    {{ $prismic.richTextAsPlain(post.data.post_title) }}
                    </router-link>
                  </p>
                  <p class="subtitle has-text-grey is-size-6">
                    <b-icon pack="fas" icon="calendar-alt" size="is-small"></b-icon><span> {{ formatDate(post.data.event_date, true) }}</span>&nbsp;&nbsp;&nbsp;
                    <b-icon pack="fas" icon="user" size="is-small"></b-icon><span> Admin</span>
                  </p>
                  <p>
                    {{ $prismic.richTextAsPlain(post.data.post_content).substr(0, 150) }} ...
                    <router-link :to="{ name: 'post', params: { uid: post.uid } }">閱讀全文</router-link>
                  </p>
                  <hr/>
                </div>

              </div>
            </div>
            <b-pagination
              :total="total"
              :current.sync="current"
              :per-page="perPage">
            </b-pagination>
          </div>

          <div class="column">
            <AnnouncementCard/>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import AnnouncementCard from '@/components/AnnouncementCard.vue';
import narrowBanner from '@/components/narrowBanner.vue';

export default {
  name: 'events',
  components: {
    AnnouncementCard,
    narrowBanner,
  },
  data() {
    return {
      posts: [],
      total: '',
      current: 1,
      perPage: 10,
      searchText: '',
      isLoading: false,
    };
  },
  methods: {
    getContent() {
      this.$prismic.client.query([
        this.$prismic.Predicates.at('document.type', 'posts'),
        this.$prismic.Predicates.fulltext('document', this.searchText),
      ], { orderings: '[my.posts.event_date desc]' }).then((response) => {
        this.isLoading = true;
        setTimeout(() => {
          this.isLoading = false;
        }, 0.5 * 1000);

        if (response.results.length === 0) {
          setTimeout(() => {
            this.$toast.open({
              message: '沒有符合搜尋字串的結果！',
              type: 'is-warning',
            });
          }, 0.5 * 1000);
        } else {
          this.posts = response.results;
          this.total = response.results.length;
        }
      });
    },

    formatDate(date, only) {
      if (only) {
        return moment(date).format('h:mm a - MMM D, YYYY').substring(11);
      }
      return moment(date).format('h:mm a - MMM D, YYYY');
    },

    charCounter(index) {
      return this.$prismic.richTextAsPlain(this.posts[index].data.post_content).length;
    },

    paginatedData(current, perPage) {
      return this.posts.slice(current * perPage - perPage, current * perPage);
    },

    resetSearch() {
      this.searchText = '';
      this.getContent();
    },
  },
  mounted() {
    this.getContent();
  },
  computed: {
  },
};
</script>

<style scoped lang="scss">
.hero-body {
  padding: 0.17rem 1.5rem;
}
</style>
